module.exports = __webpack_public_path__ + "static/media/pancakes1.2475581e.jpg";